export default "/images/vendor/flag-icon-css/flags/1x1/sd.svg?cb3da007630d3b35d1ca521bb2c76364";